import type { SavedViz } from './SavedViz.js'
import { selectSavableVizState } from './SavedViz.js'
import type { VisualizationState } from '../../../../Flux/Slice/Visualization/VisualizationSlice.js'

export type SavedAutosave = SavedViz
export type SavedTemplate = SavedViz // same schema; we just clear fields

export function pickAutosave(state: VisualizationState): SavedAutosave {
  return selectSavableVizState(state) // ✅ no snapshots/openRequests
}

export function pickTemplate(state: VisualizationState): SavedTemplate {
  const out = selectSavableVizState(state)
  // strip data-bound bits for a template
  for (const src of Object.values(out.sources)) {
    delete src.selectedBucketKeys
    // optional: neutralize zoom
    src.shared.selectedPath = []
  }
  return out
}
